import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDialogflowComponent } from './simple-icons-dialogflow.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDialogflowComponent ],
    exports:      [ SimpleIconsDialogflowComponent ],
    bootstrap:    []
})
export class SimpleIconsDialogflowModule {}
